import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ContractTierService {
  static loadContractTiers() {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACT_TIERS}`;
    return axios.get(url).then((response) => response.data);
  }

  static getContractTier(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACT_TIERS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createContractTier(contractTier) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACT_TIERS}`;
    const body = {
      contractTier
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateContractTier(contractTier) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTRACT_TIERS}/${contractTier.id}`;
    const body = {
      contractTier
    };

    return axios.put(url, body).then((response) => response.data);
  }
}

export default ContractTierService;
